import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule, MatInputModule,
  MatBadgeModule, MatButtonModule, MatButtonToggleModule,
  MatCardModule, MatCheckboxModule,  MatDatepickerModule,
  MatDialogModule,  MatDividerModule,  MatExpansionModule,
  MatGridListModule,  MatIconModule, MatListModule,
  MatMenuModule,  MatPaginatorModule,  MatRadioModule, MatRippleModule,
  MatSelectModule, MatSidenavModule, MatSliderModule, MatSlideToggleModule,
  MatSnackBarModule, MatSortModule, MatStepperModule, MatTableModule,
  MatTabsModule, MatToolbarModule, MatTooltipModule,
  MatTreeModule, MatProgressSpinnerModule, MatNativeDateModule, MatFormFieldModule,
  } from '@angular/material';
import { FormsModule } from '@angular/forms';
@NgModule({
  declarations: [],
  imports: [
    MatButtonToggleModule,
    MatStepperModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatListModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatRippleModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatSortModule,
    MatTabsModule,
    MatTooltipModule,
    MatTreeModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    CommonModule,
    MatIconModule, MatBadgeModule, MatButtonModule,
       MatCardModule,  MatStepperModule,
    MatDialogModule,
     MatMenuModule, MatSliderModule, MatSlideToggleModule,
    MatTableModule, MatToolbarModule, MatProgressSpinnerModule,
    MatSelectModule
   ],
  exports: [    MatButtonToggleModule,
    MatStepperModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatListModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatRippleModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatSortModule,
    MatTabsModule,
    MatTooltipModule,
    MatTreeModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    CommonModule,
    MatIconModule, MatBadgeModule, MatButtonModule,
       MatCardModule,  MatStepperModule,
    MatDialogModule,
     MatMenuModule, MatSliderModule, MatSlideToggleModule,
    MatTableModule, MatToolbarModule, MatProgressSpinnerModule,
    MatSelectModule
 ]
})
export class AppMaterialModule { }
